export default {
	jobForms: {
		stepsAndTasksEdit: "Редагування кроків і завдань пакета",
		app: "Програма",
		template: "Шаблон",
		block: "Заблокувати",
		tasks: "Завдання",
		base: "база",
		allBases: "всі бази",
		quanity: "кількість",
		cancel: "Скасувати",
		pathError: "Помилка в шляху завдання",
		noBaseSelectedForTask: "Для одного із завдань не вибрана база",
		problemWithAppSelect: "Проблема з вибором програми",
		tryToDeleteStepAndRecreate: "Спробуйте видалити крок і створити заново",
		incorrectlyEnteredData: "Невірно введені дані",
		oneOfParamBaseNameNotdetermined: "Один з параметрів короткого імені бази не вдалося визначити",
		baseWillNotBeAutoSubstituted: "База автоматично не підставлена",
		baseNameNoShortName: "Невірно прив'язана база, оберіть іншу та оберіть заново попередню"
	},
	packets: {
		createAppsPacket: "Створити пакет для програм",
		startOfPackageName: "Початок назви пакета (-ів)",
		apps: "Програми",
		byt: "побут",
		prom: "пром",
		clean: "очистити",
		withoutBindingToBases: "Пакет для кожної програми (бази не прив'язані)",
		packageForEveryBase: "Пакет для кожної бази",
		packageTemplate: "Шаблон для пакету",
		firstPackageStartTime: "Час запуску першого пакету",
		othersPackagesInterval: "Інтервал інших пакетів",
		cancel: "Скасувати",
		massPackageDelete: "Видалення декількох пакетів",
		showPackagesByTemplate: "Показати пакети на основі шаблону",
		packagesByThisTemplate: "Пакети на основі цього шаблону",
		selectAll: "вибрати все",
		selected: "Обрано",
		add: "Створити",
		addPackage: "Створити пакет",
		createSomePackages: "Створити кілька пакетів",
		edit: "Редагувати",
		editPackageName: "Редагувати назву пакета",
		editPackageStepsAndTasks: "Редагувати кроки і завдання пакету",
		addPackageSchedule: "Додати розклад",
		editPackageSchedule: "Редагувати розклад",
		deletePackageSchedule: "Видалити розклад",
		delete: "Видалити",
		deletePackage: "Видалити пакет",
		deletePackageByTemplate: "Видалити пакети за шаблоном",
		packageSort: "Сортування пакетів",
		name: "Ім'я",
		startTime: "Час запуску",
		templateEdited: "шаблон змінився",
		schedule: "Розклад",
		steps: "Кроки",
		enterPackageName: "Введіть назву пакета",
		selectApps: "Виберіть одну або кілька програм",
		selectPackageCreateMode: "Виберіть режим створення пакетів",
		selectPackageTemplate: "Виберіть шаблон для пакета",
		enterStartTimeOfFirstPackage: "Введіть час запуску першого пакету",
		enterPackageStartInterval: "Введіть інтервал запуску пакетів",
		thisActionDeleteScheduleOfPackage: "Ця дія видалить розклад цього пакета",
		continue: "Продовжити",
		attention: "Увага",
		cancellation: "Скасувати",
		accept: "Підтвердити",
		packageWereCreatedWithoutBases: "Були створені пакети без введених баз",
		fillBasesForEachPackage: "Заповніть бази для кожного пакету",
		notAllRequiredFieldsSelected: "Не всі обов'язкові поля введені",
		noTemplateSelected: "Не було обрано жодного шаблону",
		thisActionDeleteThisPackage: "Ця дія видалить цей пакет",
		enterNewPackageName: "Введіть нову назву пакета"
	},
	scheduleForm: {
		packageSchedule: "Розклад пакету",
		daily: "Щодня",
		weekly: "Щотижня",
		dayOfWeek: "День тижня",
		monthly: "Щомісяця",
		day: "День",
		once: "Разово",
		special: "Особливий",
		blockSchedule: "Заблокувати розклад",
		cancel: "Скасувати",
		monday: "Понеділок",
		tuesday: "Вiвторок",
		wednesday: "Середа",
		thursday: "Четвер",
		friday: "П'ятниця",
		saturday: "Субота",
		sunday: "Неділя",
		timeNotSelected: "Не встановлено час",
		dateNotSelected: "Не встановлено день",
		dayOfWeekNotSelected: "Не встановлено день тижня",
		specialExpressionNotSelected: "Особливий розклад не введено",
		incorrectFormat: "Розклад пакету '{name}' має помилки: '{schedule}', потрібно видалити розклад та створити його заново"
	},
	templateForm: {
		enterTemplateName: "Заповніть ім'я шаблону",
		templateName: "Назва шаблону",
		templateCreate: "Створення шаблону",
		cancel: "Скасувати"
	},
	templates: {
		selected: "Обрано",
		addTemplate: "Створити",
		copyTemplate: "Копіювати",
		editTemplateName: "Редагувати назву шаблону",
		editTemplateTasks: "Редагувати завдання шаблону",
		activateSchedule: "Активувати розклад",
		forbidSchedule: "Заборонити розклад",
		deleteTemplate: "Видалити",
		packageWithPreviousVersion: "існує пакет з минулою версією",
		enterTemplateNewName: "Введіть нову назву шаблону",
		enterCopyTemplateNewName: "Введіть назву копії шаблону",
		accept: "Підтвердити",
		cancellation: "Скасувати",
		thisActionDeleteThisTemplate: "Ця дія видалить цей шаблон",
		continue: "Продовжити",
		attention: "Увага",
		noTemplateFound: "Не знайдений шаблон"
	},
	templateTaskForm: {
		taskParams: "Параметри завдання",
		editTemplateTasks: "Редагування завдань шаблону",
		enterParams: "Заповнити параметри",
		cancel: "Скасувати",
		taskNotSelected: "Завдання не обране",
		youNeedEnterTaskParams: "Необхідно заповнити параметри завдання"
	}
}